import React, { useState, useEffect } from 'react';
import { X as XIcon } from 'lucide-react';
import { SEOHead } from '../components/site/SEOHead';
import api, { getFileUrl } from '../lib/api';

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterCat, setFilterCat] = useState('');
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => { api.get('/gallery?active_only=true').then(r => setItems(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  const categories = [...new Set(items.map(i => i.category).filter(Boolean))];
  const filtered = filterCat ? items.filter(i => i.category === filterCat) : items;

  return (
    <div data-testid="gallery-page">
      <SEOHead title="Galeri" />
      <div className="relative py-16 md:py-24 bg-[#0f1419]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">Galeri</h1>
          <div className="mt-4 w-16 h-1 rounded-full bg-[hsl(var(--gold))]" />
        </div>
      </div>

      <section className="py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          {categories.length > 0 && (
            <div className="flex gap-2 mb-8 flex-wrap">
              <button onClick={() => setFilterCat('')} className={`px-4 py-2 text-sm rounded-lg ${!filterCat ? 'bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))]' : 'bg-secondary'}`}>Tümü</button>
              {categories.map(c => <button key={c} onClick={() => setFilterCat(c)} className={`px-4 py-2 text-sm rounded-lg ${filterCat===c ? 'bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))]' : 'bg-secondary'}`}>{c}</button>)}
            </div>
          )}

          {loading ? <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>
          : filtered.length === 0 ? <div className="text-center py-20 text-muted-foreground">Henüz görsel yok</div>
          : <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {filtered.map((g, i) => (
              <button key={g.id} onClick={() => setLightbox(i)} className="group relative rounded-xl overflow-hidden aspect-square bg-secondary">
                <img src={getFileUrl(g.image_path)} alt={g.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.05]" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-end">
                  {g.title && <span className="p-3 text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">{g.title}</span>}
                </div>
                {g.category && <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-black/50 text-white text-[10px]">{g.category}</div>}
              </button>
            ))}
          </div>}
        </div>
      </section>

      {/* Lightbox */}
      {lightbox !== null && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center" onClick={() => setLightbox(null)}>
          <button onClick={() => setLightbox(null)} className="absolute top-4 right-4 p-2 text-white/70 hover:text-white"><XIcon className="w-6 h-6" /></button>
          <img src={getFileUrl(filtered[lightbox]?.image_path)} alt="" className="max-w-[90vw] max-h-[90vh] object-contain" onClick={e => e.stopPropagation()} />
          {filtered[lightbox]?.title && <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white text-sm font-medium bg-black/50 px-4 py-2 rounded-full">{filtered[lightbox].title}</div>}
        </div>
      )}
    </div>
  );
}
